import {Injectable} from '@angular/core'

@Injectable()
export class LocalStorageService {
  private PREFIX = 'curo'

  constructor() {}

  private getKey(name: string) {
    return this.PREFIX.concat('-', name)
  }

  setItem(name: string, value: any) {
    localStorage.setItem(this.getKey(name), value)
  }

  getItem(name: string) {
    return localStorage.getItem(this.getKey(name))
  }

  setObject(name: string, value: any) {
    localStorage.setItem(this.getKey(name), JSON.stringify(value))
  }

  getObject(name: string) {
    try {
      return JSON.parse(localStorage.getItem(this.getKey(name)))
    } catch (err) {
      this.removeItem(name)
      return null
    }
  }
  removeItem(name: string) {
    localStorage.removeItem(this.getKey(name))
  }
}
